import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Card, CardBody, CardTitle } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

import Loader from '../../components/Common/Loader';
import DmxOccupancyList from '../../components/Lists/DmxOccupancyList';
import { getDmxOccupancy } from '../../store/actions';

class DmxUniverseOccupancy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      devices: null,
    };
  }

  componentDidMount() {
    this.props.getDmxOccupancy(this.state.user, this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.occupancyDevices !== prevProps.occupancyDevices) {
      this.setState({ devices: this.props.occupancyDevices });
    }
  }

  goBack(event) {
    event.preventDefault();
    this.props.history.goBack();
  }

  render() {
    if (!this.state.devices) {
      return (
        <div className="loaderCenter">
          <Loader></Loader>
        </div>
      );
    }
    return (
      <div className="user-management">
        <Container fluid>
          <Button
            className="btn btn-primary waves-effect waves-light usersButtons"
            onClick={(event) => this.goBack(event)}
          >
            <i className="fas fa-arrow-left"></i>
          </Button>
          <Button className="btn btn-primary waves-effect waves-light buttonStatus usersButtons">
            <Link
              to={{
                pathname: '/createDmxDevice',
                state: { universeId: this.props.match.params.id },
              }}
            >
              {this.props.t('Crear dispositivo')}
            </Link>
          </Button>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{this.props.t('Ocupación de canales')}</CardTitle>
              <DmxOccupancyList devices={this.state.devices} universeId={this.props.match.params.id} />
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { occupancyDevices } = state.getDmxOccupancy;
  return { occupancyDevices };
};

export default withRouter(connect(mapStateToProps, { getDmxOccupancy })(withNamespaces()(DmxUniverseOccupancy)));
